import { render, staticRenderFns } from "./NewsItem3.vue?vue&type=template&id=0f050081"
import script from "./NewsItem3.vue?vue&type=script&lang=ts"
export * from "./NewsItem3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports